const gateway = `https://api-gateway-dev.way2vat.com`;
const core = `https://api-gateway-dev.way2vat.com`;
const allServices = "https://dev-w2v.way2vat.com";

export const environment = {
  name: "development",
  production: false,
  qa: true,
  dev: false,
  dataManagementUserIds: [1919, 1214, 2012, 2003, 1967, 2011, 2034, 2042, 2041, 2044],
  gw: gateway,
  gateway: `${gateway}/w2v`,
  configuration: `${gateway}/w2v/configuration/configurations`,
  transformer: `${gateway}/w2v/transformer`,
  extractor: `${gateway}/w2v/extractor`,
  storm: `${gateway}/storm`,
  wv: `${gateway}/wolverine`,
  wvgql: `${gateway}/wolverine/graphql`,
  apai: `${gateway}/apai-web`,
  apaigql: `${gateway}/apai-web/graphql`,
  configgql: `${gateway}/w2v/account-configuration/graphql`,
  phoenixGql: `${gateway}/phoenix/graphql`,
  authGql: `${gateway}/phoenix/auth`,
  exporter: `${gateway}/w2v/exporter`,
  transformerQl: `${gateway}/w2v/transformer/ql`,
  connector: `${gateway}/api-connector`,
  core: `${core}/core/ql`,
  api: `${core}/core/api`,
  auth: `${core}/auth`,
  ms: `${core}/w2v/vat-calculator`,
  media: `${core}/core/media-service`,
  newMedia: `${gateway}/w2v/media/v2/media`,
  request: `${core}/core/api/connections/request`,
  download: `${gateway}/api/media/download`,
  divaEInvoicingApiBaseUrl:
    "https://enorhpc006.execute-api.eu-south-2.amazonaws.com/dev",
  analyticsTrackingCode: "UA-89763800-5",
  apaiDownload: `${gateway}/api/media/download/apai`,
  jsonSchemasUrl: "https://dev-app.way2vat.com/json-schemas",
  phoenixMapsKeyUrl: `${gateway}/phoenix/location/key`,
  trackPipelineUrl: `${gateway}/expenses-pipeline/pipeline/`,
  tidioPublicKey: "nvf96dnbr3ssfzibqyeuq08tb3rli3yd",
  // graphQlLinkUri: `http://172.19.1.62:8080`
};
